import { useCallback } from 'react';

import { ListEntityType } from 'src/services/lists/lists.types';
import { CsvImportRow, CsvImportOptions } from 'src/services/common.types';
import { CustomFieldEntityType } from 'src/services/custom-fields/custom-field.types';
import { useCsvImportCandidatesMutation } from 'src/services/candidates/candidates.service';

import CsvImportDialog, { CsvImportResult } from 'src/sections/import/csv-import-dialog';

type Props = {
  open: boolean;
  organizationId?: string | undefined;
  onClose: VoidFunction;
};

const resultLabel = (result: CsvImportResult) => result.email ?? '';

export default function BulkCandidateImportModal({ open, onClose, organizationId }: Props) {
  const [csvImportCandidates, { isLoading }] = useCsvImportCandidatesMutation();

  const handleImport = useCallback(
    (rows: CsvImportRow[], options: CsvImportOptions) =>
      csvImportCandidates({ organization_id: organizationId, candidates: rows, ...options }).unwrap(),
    [csvImportCandidates, organizationId]
  );

  return (
    <CsvImportDialog
      open={open}
      onClose={onClose}
      organizationId={organizationId}
      entity="candidate"
      customFieldEntityType={CustomFieldEntityType.CANDIDATE}
      listEntityType={ListEntityType.CANDIDATE}
      i18nPrefix="candidates.import_modal"
      templateFileName="Candidate Import Template.csv"
      isImporting={isLoading}
      onImport={handleImport}
      resultLabel={resultLabel}
    />
  );
}
